/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Helmet from 'react-helmet';
/* eslint-enable import/no-extraneous-dependencies */

import Hero from '../../components/hero';
import PostListingCard from '../../components/PostListingCard';

import styles from '../../pageComponents/card.module.css';

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark ? data.allMarkdownRemark : { edges: [] };
  return ([
    <Helmet key="blogListingHelmet" title="Our Thoughts" />,
    <Hero color="blue" gradient key="blogListingHero">
      Our Thoughts
    </Hero>,
    <div key="blogListingContent" className={styles.singleCard}>
      {posts
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }, index) => (
          <PostListingCard key={`${post.frontmatter.title}${post.id}`} post={post} index={index} color="blue" />
        ))}
    </div>,
  ]);
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "blog" }, published: {eq: true} } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            tags
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog/index.jsx